import { useTelescopeContext } from "@hubble/telescope";
import { goBack } from "~/shared_states/modal";

const BUDDYDEALS_WHATSAPP_NUMBER = "9467803957";
const BUDDYDEALS_WHATSAPP_LINK = "https://wa.me/message/X7KQWSUN2GXPE1";

export function BuddyDealsContactSupportModal() {
  const { components } = useTelescopeContext();

  const handleContactNow = () => {
    window.open(BUDDYDEALS_WHATSAPP_LINK, "_blank");
    goBack();
  };

  return (
    <div class="flex w-full flex-col overflow-hidden rounded-2xl bg-background-normal-primary">
      {/* Modal Header */}
      <components.ModalHeader
        size="medium"
        title="Contact support"
        onClose={() => goBack()}
      />

      {/* Modal Body */}
      <div class="flex flex-col items-center gap-1 px-4 py-6 text-center">
        <p class="text-para-2-regular text-text-normal-secondary">
          You can reach us on WhatsApp
        </p>
        <p class="text-title-3-semi-bold text-text-normal-primary">
          {BUDDYDEALS_WHATSAPP_NUMBER}
        </p>
      </div>

      {/* Modal Footer */}
      {/* <div class="border-t border-stroke-1"> */}
      <components.ModalFooter
        leftButton={{
          text: "Cancel",
          onClick: () => goBack(),
          variant: "secondary",
          style: "neutral",
          size: 40,
          expanded: true,
        }}
        rightButton={{
          text: "Contact now",
          onClick: handleContactNow,
          variant: "primary",
          style: "neutral",
          size: 40,
          expanded: true,
        }}
      />
      {/* </div> */}
    </div>
  );
}
